import {Endpoint} from '@eryxcoop/appyx-comm';

export default class MarkOrderAsPendingEndpoint extends Endpoint {

  adaptValues(orderNumber) {
    return {
      'order_number': orderNumber
    }
  }
}